<template>
  <div>
    <h1 class="page-header">{{ $t('department.department') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              :leave="route_leave"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div
                class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start"
              ></div>
              <div
                class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end"
              >
                <ts-input
                  v-model="search"
                  :placeholder="$t('department.search')"
                  style="width: 300px;"
                  class="kh-font"
                />
              </div>
            </div>
          </ts-card-wrapper>
          <ts-table :columns="columns" :records="resources" :loading="loading">
            <template v-slot="{ record }">
              <td>{{ record.department_code }}</td>
              <td class="kh-font">{{ record.department_name_kh }}</td>
              <td>{{ record.department_name_en }}</td>
              <td>
                {{
                  record.division !== null
                    ? record.division.division_name_en
                    : ''
                }}
              </td>
              <td class="text-center">
                <a
                  href="#"
                  title="edit"
                  class="text-primary mr-2"
                  @click.prevent="edit(record)"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <a
                  href="#"
                  title="delete"
                  class="text-danger"
                  @click.prevent="destroy(record.department_id)"
                >
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </template>
          </ts-table>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'department',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      route_leave: false,
      columns: [
        { name: this.$t('department.code') },
        { name: this.$t('department.nameKh') },
        { name: this.$t('department.nameEn') },
        { name: this.$t('department.division') },
        {
          name: this.$t('department.actions'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('department', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.department.search
      },
      set(newVal) {
        this.$store.commit('department/SET_SEARCH', newVal)
        this.$store.commit('department/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('department/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit(data) {
      this.route_leave = false
      this.edit_data = data
      this.$router.push(`/departments/${data.department_id}`)
    },

    async destroy(id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('department/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'department-create') {
      this.$store.commit('department/RESET_STATE')
      this.fetchData()
      this.route_leave = true
    }
    next()
  }
}
</script>
